<template>
  <router-view :key="$route.path"></router-view>
</template>

<script>
import axios from 'axios'
import router from '@/router'
import { mapActions } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useI18n } from "vue-i18n";
import Trans from "@/I18n/translation";
export default {
  methods: {
    ...mapActions(useAuthStore, ['logout']),
  },
  data() {
    return {
      $t: useI18n().t,
    }
  },
  mounted() {
    axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      console.error(error)
      if (error.response.status === 401 || error.response.status === 419) {
        if (error.response.data.message === 'CSRF token mismatch.') return
        // this.logout()
        //   .catch((error) => { console.error(error) })
        // router.replace({ name: 'Login' })

        toast.error(this.$t('messages.static.please_login'), { position: "top-center",theme: "colored",type: "error", duration: 3000, closeOnClick: true, rtl: Trans.getPersistedLocale() == 'ar', });

      } else if (error.response.status === 403) {
        //router.push({ name: 'VerifyEmail' })
      } else if (error.response.status === 423) {
        router.push({ name: 'ConfirmPassword' })
      }

      return Promise.reject(error);
    });
  },
}
</script>
